import React, { Fragment } from 'react'
import { Frame, SpacerVertical, Typography } from '@klarna/bubble-ui'

import LoadingSpinner from '../../../LoadingSpinner'
import { BespokeInterstitialProps } from '../types'
import LearnMoreTimeline from '../../Timeline'
import { KlarnaDealBadge } from '../../content/KlarnaDealBadge'
import styles from './ExternalContent.css'
import LegalLink from '../../../../../common/components/LegalLink'
import DisclaimerFrame from './DisclaimerFrame'

export const ExternalContent = ({ copy }: BespokeInterstitialProps) => (
  <Fragment>
    <style>{styles}</style>
    {!copy ? (
      <LoadingSpinner />
    ) : (
      <div>
        <KlarnaDealBadge />
        <SpacerVertical spaceToken="space.200" />
        <div className='titleContainer'>
          <Typography
            textToken="text-style/headings/titles/bold/secondary"
            colorToken="colors/text/default"
            textAlignToken="text-alignment/center"
          >
            {copy.title}
          </Typography>
        </div>
        <SpacerVertical spaceToken="space.400" />
        {copy.disclaimer_text
        && <DisclaimerFrame
          title={copy.disclaimer_text}
          items={copy.disclaimer_item_list}
        ></DisclaimerFrame>
        }
        <SpacerVertical spaceToken="space.400" />
        <Frame
          backgroundColorToken="colors/backgrounds/default"
          cornerRadiusToken="corner-radius/m"
          paddingToken='space.200'
        >
          <Typography
            textToken='text-style/text/paragraphs/body/medium'
            colorToken='colors/text/default'
            textAlignToken="text-alignment/start"
          >
            {copy.timeline_header}
          </Typography>
          <SpacerVertical spaceToken="space.150" />
          <LearnMoreTimeline copy={copy.timeline} spacer={false} />
        </Frame>
        <SpacerVertical spaceToken="space.300" />
        <Typography
          textToken="text-style/text/super-paragraphs/tiny/regular"
          colorToken="colors/text/neutral"
          textAlignToken="text-alignment/start"
        >
          <LegalLink textToken={'text-style/text/super-paragraphs/tiny/regular'}
            colorToken={'colors/text/neutral'}
            legalText = {copy.legal.text}/>
        </Typography>
      </div>
    )}
  </Fragment>
)